import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { Key } from '@/types';

export const getCapitolKeys = async (): Promise<Key[]> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest<Key[]>({
    url: `/internal-api-keys/${orgId}`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to get capitol keys');
  }

  return response.data ?? [];
};
